import AWS from 'aws-sdk';
import api from './api.js';
import config from '../config';
import {store} from '../store';
import auth0 from 'auth0-js';
import router from '../router';

const auth0WebAuth = new auth0.WebAuth({
	domain: process.env.BA_AUTH0_DOMAIN,
	clientID: process.env.BA_AUTH0_CLIENTID,
	redirectUri: `${process.env.BASE_URL}/auth0`,
	responseType: 'token id_token',
	scope: 'openid',
})

export async function requireAuth(to, from, next) {
	if (localStorage.getItem('loggedIn') === 'true') {
		await checkSession();

    if(!store.getters.fullname) {
      next(false);
      login(to);
      return;
    }

		if(!store.state.propertyLists) {
			// get properties lists
			const propertyLists = await api({endpoint: config.services.properties, path: '/lists', method: 'GET'});
			store.commit('setPropertyLists', propertyLists);
		}

		if(!store.getters.companyActive && to.path !== '/company-setup') {
			next('/company-setup');
		} else {
			next();
		}
	} else {
		next(false);
		login(to);
	}
}

export async function requireAdmin(to, from, next) {
	if (localStorage.getItem('loggedIn') === 'true') {
		await checkSession();

		if(store.getters.admin && store.getters.admin === true) {
			next();
		} else {
			next('/');
		}
	} else {
		logout();
	}
}

const login = (to) =>  {
	auth0WebAuth.authorize({
		redirectUri: `${process.env.BASE_URL}/auth0`,
		mode: to.name === 'NewUser' ? 'signUp' : 'login'
	});
}

export function handleAuthentication() {
	auth0WebAuth.parseHash(async (err, authResult) => {
		if (authResult && authResult.accessToken && authResult.idToken) {
			await setSession(authResult);

			const userId = authResult.idTokenPayload.sub;
			const user = await api({endpoint: config.services.companies, path: '/setupUser', method: 'POST', body: {token: userId}});

			store.commit('setFullname', user.name);
			store.commit('setPhoto', user.photo);
			store.commit('setCompanyId', user.companyId);
			store.commit('setCompanyName', user.companyName);
			store.commit('setCompanyActive', user.companyActive);
			store.commit('setDemoMode', user.demoMode);
			store.commit('setEmail', user.email);
			store.commit('setProPortalsPerProperty', user.pro && user.pro.portalsPerProperty ? user.pro.portalsPerProperty : false);
			store.commit('setSubscriptions', user.subscriptions);

			if(user.admin) {
				store.commit('setAdmin', user.admin);
				store.commit('setAdminCompanyId', user.adminCompanyId);
				router.replace('/admin');
				return;
			}

			if(user.companyActive) {
				const properties = await api({endpoint: config.services.properties, path: '/', method: 'GET'});
				if(properties.length == 0) {
					router.replace('/start');
				} else {
					router.replace('/');
				}
			} else {
				router.replace('/company-setup');
			}
		} else if (err) {
			console.error(err);
			logout();
		}
	});
}

const setSession = async (authResult) => {
	await getAwsCredentials(authResult.idToken);
	localStorage.setItem('loggedIn', true);
	const now = new Date().getTime();
	const expireTime = now + (authResult.expiresIn * 1000) - (5 * 60 * 1000);
	const expireTimeStr = new Date(expireTime);
	localStorage.setItem('expireTime', expireTime);
}

const renewSession = async () => {
	return new Promise(async (resolve, reject) => {
		auth0WebAuth.checkSession({}, async (err, authResult) => {
			if (authResult && authResult.accessToken && authResult.idToken) {
				await setSession(authResult);
				resolve();
			} else if (err) {
				logout();
				console.error(err);
				reject();
			}
		});
	});
}

export function logout() {
	localStorage.removeItem('loggedIn');
	localStorage.removeItem('expireTime');

	store.commit('clearAll');

	if (AWS.config.credentials) {
		AWS.config.credentials.clearCachedId();
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
	}

	auth0WebAuth.logout({
		returnTo: process.env.BASE_URL,
	});
}

const getAwsCredentials = async function(token) {
	AWS.config.update({ region: config.aws.region });

	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: config.aws.identityPoolId,
		Logins: {
			[process.env.BA_AUTH0_DOMAIN]: token
		}
	});

	return AWS.config.credentials.getPromise();
}

const checkSession = async () => {
	let now = new Date().getTime();
	if (!AWS.config.credentials || now > AWS.config.credentials.expireTime.getTime() || now > localStorage.getItem('expireTime')) {
		await renewSession();
	}
}

export async function isLoggedIn() {
	if (localStorage.getItem('loggedIn') === 'true') {
		await checkSession();
		return true;
	} else {
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/libs/auth0.js